// Footer.js
import React from 'react';
import {FaFacebook, FaWhatsapp} from 'react-icons/fa';
// import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa'; // Import the icons
import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
  const handleFooterLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-brand-title">Divine-Tech Engineering</div>
            <div className="footer-brand-subtitle">Engineering Solutions That Flow.</div>
            <div className="footer-brand-copy">
              Water systems installation, mechanical works, fabrication, and maintenance services across Malawi.
            </div>
          </div>

          <div className="footer-links-col">
            <div className="footer-col-title">Quick Links</div>
            <ul className="footer-links">
              <li><Link to="/about" onClick={handleFooterLinkClick}>About Us</Link></li>
              <li><Link to="/services" onClick={handleFooterLinkClick}>Services</Link></li>
              <li><Link to="/projects" onClick={handleFooterLinkClick}>Projects</Link></li>
              <li><Link to="/contact" onClick={handleFooterLinkClick}>Contact</Link></li>
            </ul>
          </div>

          <div className="footer-social-col">
            <div className="footer-col-title">Connect</div>
            <div className="social-icons">
          
              <a href="https://www.facebook.com/divinetechtechnologies" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
                </a>

                <a href="https://wa.me/0995543765" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                  <FaWhatsapp />
                </a>

            {/*  <a href="#" aria-label="Twitter" title="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Instagram" title="Instagram"><FaInstagram /></a> */}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copy">
            &copy; {new Date().getFullYear()} Divine-Tech Engineering (DTE). All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
